export const palette = {
  primary: '#1F6863',
  secondary: '#FEA400',
  tertiary: '#F4D35E',
  fourth: '#172325',
  alert: '#ffa000',
  white: '#fff',
  black: '#000814',
};
